<mat-form-field class="example-full-width" appearance="outline">
    <mat-label>{{placeholder}}</mat-label>
    <input matInput [disabled]="true" [ngModel]="fileNames.join(',')">
    <button  mat-stroked-button matSuffix color="primary" type="button" (click)="onClickButton($event)">
        <mat-icon>upload</mat-icon> Choose File
    </button>
    <input accept="image/png,image/jpg,image/jpeg" class="di-file-input" type="file" (change)="onFileSelect($event)" #fileInput />
  </mat-form-field>
